import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from 'react-router-dom'

function MasterIntent(props) {
    const [formData, setName] = useState({ intentname: "" });
    const navigate = useHistory();
    const [PortalList, setPortalList] = useState([])
    const [PoralId, setPortalId] = React.useState('');

    useEffect(() => {

        LoadPortals();

    }, [])
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`)
            .then(res => {
                //console.log("list", res.data)
                setPortalList(res.data)
            })
    }

    const Intentsubmit = async (e) => {
        e.preventDefault();
        //console.log("formData", formData)
        if (formData.intentname === "" || PoralId === "") {
            if (formData.intentname === "") {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
            if (PoralId === "") {
                Swal.fire({
                    title: "Error",
                    text: "Please Select Portal",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        }
        else {

            const datavalue = {
                "intents": formData.intentname,
                "portal_Id": PoralId

            }

            //console.log("json data", JSON.stringify(datavalue))
            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/AddMasterIntent`,
                data: JSON.stringify(datavalue),
                headers: { 'Content-Type': 'application/json' },
                json: true,
            };
            axios(authOptions)
                .then((res) => {
                    //console.log("success", res.data.SuccessResult)
                    if (res.data.SuccessResult === "already") {
                        Swal.fire({
                            title: "Error",
                            text: "Intent already inserted with this Portal",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    } else {
                        setName({ intentname: "" });
                        Swal.fire({
                            title: "Success",
                            text: "Intent Added Successfully",
                            icon: "success",
                            confirmButtonText: "Ok",
                        }).then(function () {
                            // window.location.pathname = "/IntentAns";
                            // navigate.push('/');
                        });

                    }
                })
                .catch(error => {
                    //console.log("error occur", error);
                })
        }
    }

    const handleChangePortal = (event) => {

        setPortalId(event.target.value);
        //console.log("selected Portal", event.target.value)

    };
    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    const BackFunc = () => {
        navigate.push('/index')
    }

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-middle">
                                {/* <div className="page-title">Add Patient</div> */}
                            </div>
                            <div className=" pull-right">

                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 col-sm-2">
                        </div>
                        <div className="col-md-8 col-sm-8">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Add Intents</header>

                                </div>
                                <div className="card-body " id="bar-parent1">
                                    <form className="register-form" id="login-form" onSubmit={Intentsubmit}>

                                        <div className="form-group row">
                                            <label for="horizontalFormEmail"
                                                className="col-sm-3 control-label">Intent</label>
                                            <div className="col-sm-9">

                                                <input type="text"
                                                    value={formData.intentname}
                                                    onChange={handleChange}
                                                    name="intentname" className="form-control" id="simpleFormEmail"
                                                    placeholder="Enter Intent" />
                                            </div>
                                        </div>
                                        <div className="form-group row">

                                            <label for="horizontalFormEmail"
                                                className="col-sm-3 control-label">Portal</label>
                                            <div className="col-sm-9">
                                                <select className="form-control select2" onChange={handleChangePortal}>
                                                    <option value="" >--Select--</option>
                                                    {
                                                        PortalList.map((result, i) => {
                                                            return (
                                                                <option value={result.id} key={result.id}>{result.portal_Name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-12 text-end">
                                                <button type="submit" className="btn btn-primary d-inline-block">Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default MasterIntent;